import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PlatformOverviewHero } from '../components/platformOverview/PlatformOverviewHero';
import { PlatformOverviewCore } from '../components/platformOverview/PlatformOverviewCore';
import { PlatformOverviewCapacity } from '../components/platformOverview/PlatformOverviewCapacity';
import { PlatformFaq } from '../components/platformOverview/PlatformFaq';
export function Platform() {
  return <div className="w-full min-h-screen bg-white" data-id="element-8560" data-mp="2wo7ztegvzyiv">
      <Header data-id="element-8561" data-mp="2wmn3pkexc7iw" />
      <main className="pt-[120px]" data-id="element-8562" data-mp="2wmeovmz8qs52">
        <PlatformOverviewHero data-id="element-8563" data-mp="31eodmzomdm5r" />
        <PlatformOverviewCore data-id="element-8564" data-mp="31gj1alr9zsdj" />
        <PlatformOverviewCapacity data-id="element-8565" data-mp="31hk9migwq0rk" />
        <PlatformFaq data-id="element-8566" data-mp="36esx8yktqx07" />
      </main>
      <Footer data-id="element-8567" data-mp="36drjungc5yfb" />
    </div>;
}